<script>
import { Option, Select, Table, TableColumn, Dialog, Button, Checkbox } from "element-ui";
import serverSidePaginationMixin from "../Tables/PaginatedTables/serverSidePaginationMixin";
import "sweetalert2/src/sweetalert2.scss";

let timeout = null;

export default {
  name: "leads-list",
  mixins: [serverSidePaginationMixin],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      loading: false,
      searchQuery: "",
      filterType: "all", // 'all' | 'abandoned'
      tableData: [],
      detailModalVisible: false,
      detailLead: null,
      detailLoading: false,
      selectedLeadId: null,
      // Send email to lead (abandon cart)
      sendEmailModalVisible: false,
      emailTemplates: [],
      selectedEmailTemplate: null,
      emailSubject: "",
      emailMessage: "",
      includeLeadInfo: false,
      previewModalVisible: false,
      previewHtml: "",
      previewSubject: "",
      previewLoading: false,
      emailSending: false,
    };
  },
  watch: {
    searchQuery() {
      clearTimeout(timeout);
      timeout = setTimeout(() => this.fetchData(), 300);
    },
    filterType() {
      this.changePage(1);
    },
    $route: {
      handler(route) {
        if (route.path === "/abandon_carts" || route.query.filter === "abandoned") {
          this.filterType = "abandoned";
          this.sortedColumn = 7;
          this.order = "desc";
        } else {
          this.filterType = "all";
        }
      },
      immediate: true,
    },
  },
  created() {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
    }
    this.setDefaultFilterData();
  },
  mounted() {
    if (this.$route.path === "/abandon_carts" || this.$route.query.filter === "abandoned") {
      this.filterType = "abandoned";
      this.sortedColumn = 7;
      this.order = "desc";
    }
    this.fetchData();
  },
  computed: {
    leadDetailDialogWidth() {
      if (typeof window === "undefined") return "680px";
      return window.innerWidth <= 576 ? "95%" : window.innerWidth <= 768 ? "90%" : "680px";
    },
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http
        .post("/leads/list", {
          search: this.searchQuery,
          page: this.currentPage,
          per_page: this.perPage,
          column: this.sortedColumn,
          order: this.order,
          filter: this.filterType,
        })
        .then((response) => {
          this.tableData = response.data.data || [];
          this.totalData = response.data.total || 0;
        })
        .catch(() => {
          this.tableData = [];
          this.totalData = 0;
        })
        .finally(() => (this.loading = false));
      this.saveSearchData();
    },
    resetFilters() {
      this.searchQuery = "";
      this.filterType = "all";
      this.changePage(1);
    },
    saveSearchData() {
      localStorage.setItem(
        "leads-filters",
        JSON.stringify({
          role: "super-admin",
          search: this.searchQuery,
          filter: this.filterType,
          page: this.currentPage,
          per_page: this.perPage,
        })
      );
    },
    setDefaultFilterData() {
      const previousStateData = JSON.parse(
        localStorage.getItem("leads-filters")
      );
      if (previousStateData !== null) {
        this.searchQuery =
          previousStateData.search != undefined
            ? previousStateData.search
            : this.searchQuery;
        this.filterType =
          previousStateData.filter != undefined
            ? previousStateData.filter
            : this.filterType;
        this.perPage =
          previousStateData.per_page != undefined
            ? previousStateData.per_page
            : this.perPage;
      }
    },
    formatDate(iso) {
      if (!iso) return "—";
      try {
        const d = new Date(iso);
        return d.toLocaleDateString(undefined, {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      } catch {
        return iso;
      }
    },
    statusBadgeClass(status) {
      return status === "converted" ? "badge-success" : "badge-warning";
    },
    openLeadDetail(row) {
      this.selectedLeadId = row.id;
      this.detailModalVisible = true;
      this.detailLead = null;
      this.fetchLeadDetail(row.id);
    },
    closeLeadDetail() {
      this.detailModalVisible = false;
      this.detailLead = null;
      this.selectedLeadId = null;
    },
    fetchLeadDetail(id) {
      this.detailLoading = true;
      this.$http
        .get(`/leads/${id}`)
        .then((response) => {
          if (response.data && response.data.status && response.data.data) {
            this.detailLead = response.data.data;
          }
        })
        .catch(() => {
          this.detailLead = null;
        })
        .finally(() => (this.detailLoading = false));
    },
    detailValue(val) {
      if (val === null || val === undefined || val === "") return "—";
      if (typeof val === "object") return JSON.stringify(val);
      return val;
    },
    detailMoney(val) {
      if (val === null || val === undefined || val === "") return "—";
      const n = Number(val);
      if (Number.isNaN(n)) return val;
      return "$" + n.toFixed(2);
    },
    /** Parse addons_ids (JSON string) and return array of addon keys; empty array if none. */
    parseAddonsIds(addonsIds) {
      if (addonsIds == null || addonsIds === "") return [];
      try {
        const parsed = typeof addonsIds === "string" ? JSON.parse(addonsIds) : addonsIds;
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    },
    /** Human-readable label for addon key (e.g. hours_safety -> 24-Course Safety Training). */
    addonKeyToLabel(key) {
      const labels = {
        hours_safety: "24-Course Safety Training",
        upload_training: "Create Your Own Courses",
        sms_support: "SMS Notifications",
        call_location: "Call Location",
        surveys: "Surveys",
        on_boarding: "Onboarding",
      };
      return labels[key] || key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    },
    formatAddonsShort(addonsIds) {
      const keys = this.parseAddonsIds(addonsIds);
      if (keys.length === 0) return "—";
      return keys.map((k) => this.addonKeyToLabel(k)).join(", ");
    },
    /** Human-readable plan name (e.g. hot -> Hot Plan, sizzling -> Sizzling Plan). */
    formatPlanName(planKey) {
      if (planKey == null || planKey === "") return "—";
      const names = {
        hot: "Hot Plan",
        sizzling: "Sizzling Plan",
        scorching: "Scorching Plan",
      };
      return names[planKey] || String(planKey).replace(/\b\w/g, (c) => c.toUpperCase());
    },
    openSendEmail() {
      if (!this.detailLead || !this.detailLead.email) return;
      this.selectedEmailTemplate = null;
      this.emailSubject = "";
      this.emailMessage = "";
      this.sendEmailModalVisible = true;
      this.loadEmailTemplates();
    },
    closeSendEmail() {
      this.sendEmailModalVisible = false;
      this.selectedEmailTemplate = null;
      this.emailSubject = "";
      this.emailMessage = "";
      this.includeLeadInfo = false;
    },
    loadEmailTemplates() {
      this.$http.get("/email-marketing/marketing-templates").then((res) => {
        this.emailTemplates = (res.data && res.data.data) ? res.data.data : [];
        if (this.emailTemplates.length && !this.selectedEmailTemplate) {
          this.selectedEmailTemplate = this.emailTemplates[0].id;
        }
      }).catch(() => {
        this.emailTemplates = [];
      });
    },
    previewEmail() {
      if (!this.selectedLeadId || !this.selectedEmailTemplate || !this.emailSubject.trim() || !this.emailMessage.trim()) {
        this.$message.warning("Please select a template, enter a subject, and a message.");
        return;
      }
      this.previewLoading = true;
      this.$http
        .post(`/leads/${this.selectedLeadId}/email-preview`, {
          data: {
            subject: this.emailSubject.trim(),
            body: this.emailMessage.trim(),
            template: this.selectedEmailTemplate,
            include_lead_info: this.includeLeadInfo,
          },
        })
        .then((res) => {
          this.previewSubject = res.data.subject || "";
          this.previewHtml = res.data.html || "";
          this.previewModalVisible = true;
        })
        .catch((err) => {
          const msg = err.response && err.response.data && (err.response.data.errors && err.response.data.errors.error || err.response.data.message) || "Failed to load preview.";
          this.$message.error(msg);
        })
        .finally(() => (this.previewLoading = false));
    },
    closePreview() {
      this.previewModalVisible = false;
      this.previewHtml = "";
      this.previewSubject = "";
    },
    sendLeadEmail() {
      if (!this.selectedLeadId || !this.selectedEmailTemplate || !this.emailSubject.trim() || !this.emailMessage.trim()) {
        this.$message.warning("Please select a template, enter a subject, and a message.");
        return;
      }
      this.emailSending = true;
      this.$http
        .post(`/leads/${this.selectedLeadId}/send-email`, {
          data: {
            subject: this.emailSubject.trim(),
            body: this.emailMessage.trim(),
            template: this.selectedEmailTemplate,
            include_lead_info: this.includeLeadInfo,
          },
        })
        .then(() => {
          this.$message.success("Email sent successfully.");
          this.closeSendEmail();
        })
        .catch((err) => {
          const msg = err.response && err.response.data && (err.response.data.errors && err.response.data.errors.error || err.response.data.message) || "Failed to send email.";
          this.$message.error(msg);
        })
        .finally(() => (this.emailSending = false));
    },
  },
};
</script>

<template>
  <div>
    <div class="content">
      <div class="promo-code-wrap">
        <card
          class="no-border-card"
          footer-classes="pb-2"
          v-loading.fullscreen.lock="loading"
        >
          <template slot="header">
            <div class="row align-items-center">
              <div class="col-lg-4 dash-header">
                <h2 class="mb-0">{{ filterType === 'abandoned' ? 'Abandon Carts' : 'Leads' }}</h2>
              </div>
              <div class="col-lg-8 col-md-6 text-right">
                <base-button type="primary" outline="true" @click="resetFilters()">
                  <i aria-hidden="true" class="fa fa-refresh"></i> Clear Filters
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div class="row d-flex justify-content-start flex-wrap">
              <div class="col-md-4 search-style mb-2">
                <base-input
                  label="Search:"
                  placeholder="Name, email, company..."
                  prepend-icon="fas fa-search"
                  v-model="searchQuery"
                ></base-input>
              </div>
              <div class="col-md-3 mb-2">
                <label class="form-label">View</label>
                <el-select
                  v-model="filterType"
                  class="select-primary w-100"
                  placeholder="Filter"
                >
                  <el-option label="All leads" value="all"></el-option>
                  <el-option label="Abandoned carts only" value="abandoned"></el-option>
                </el-select>
              </div>
              <div class="col-md-3 select-style">
                <base-input label="Showing:">
                  <el-select
                    class="select-primary pagination-select"
                    placeholder="Per page"
                    v-model="perPage"
                    @change="changePage(1)"
                  >
                    <el-option
                      v-for="item in perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                      class="select-primary"
                    ></el-option>
                  </el-select>
                </base-input>
              </div>
            </div>
            <div class="user-eltable table-style-fancy border overflow-hidden">
              <el-table
                :data="tableData"
                class="compGrid compGrid-clickable"
                header-row-class-name="thead-light"
                highlight-current-row
                id="tbl-leads"
                role="table"
                row-key="id"
                stripe
                @row-click="openLeadDetail"
              >
                <el-table-column min-width="120px" label="First Name">
                  <template slot="header">
                    <span @click="sortByColumn(1)">
                      First Name
                      <i
                        v-if="sortedColumn === 1 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else-if="sortedColumn === 1"
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ props.row.first_name || "—" }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="120px" label="Last Name">
                  <template slot="header">
                    <span @click="sortByColumn(2)">
                      Last Name
                      <i
                        v-if="sortedColumn === 2 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else-if="sortedColumn === 2"
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ props.row.last_name || "—" }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="180px" label="Email">
                  <template slot="header">
                    <span @click="sortByColumn(3)">
                      Email
                      <i
                        v-if="sortedColumn === 3 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else-if="sortedColumn === 3"
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ props.row.email || "—" }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="140px" label="Company">
                  <template slot="header">
                    <span @click="sortByColumn(4)">
                      Company
                      <i
                        v-if="sortedColumn === 4 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else-if="sortedColumn === 4"
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ props.row.company_name || "—" }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="90px" label="Type">
                  <template slot="header">
                    <span @click="sortByColumn(5)">
                      Type
                      <i
                        v-if="sortedColumn === 5 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else-if="sortedColumn === 5"
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ props.row.user_type ? props.row.user_type.charAt(0).toUpperCase() + props.row.user_type.slice(1) : "—" }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="120px" label="Plan" prop="selected_course_type">
                  <template slot-scope="scope">
                    <span>{{ formatPlanName(scope.row.plan || scope.row.selected_course_type) }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="100px" label="Locations / Users">
                  <template slot-scope="props">
                    <span v-if="props.row.user_type === 'company'">
                      {{ props.row.number_of_locations || 0 }} / {{ props.row.number_of_employees || 0 }}
                    </span>
                    <span v-else>—</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="140px" label="Add-ons">
                  <template slot-scope="props">
                    <span :title="formatAddonsShort(props.row.addons_ids)">{{ formatAddonsShort(props.row.addons_ids) }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="100px" label="Est. cost/mo">
                  <template slot="header">
                    <span @click="sortByColumn(6)">
                      Est. cost/mo
                      <i
                        v-if="sortedColumn === 6 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else-if="sortedColumn === 6"
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="scope">
                    <span>{{ scope.row.cost_per_month != null ? '$' + Number(scope.row.cost_per_month).toFixed(2) : "—" }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="100px" label="Per loc / user">
                  <template slot-scope="scope">
                    <span v-if="scope.row.user_type === 'company' && (scope.row.per_location != null || scope.row.per_user != null)">
                      {{ scope.row.per_location != null ? '$' + Number(scope.row.per_location).toFixed(2) : '—' }} / {{ scope.row.per_user != null ? '$' + Number(scope.row.per_user).toFixed(2) : '—' }}
                    </span>
                    <span v-else>—</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="100px" label="Status">
                  <template slot-scope="props">
                    <span :class="['badge', statusBadgeClass(props.row.status)]">
                      {{ props.row.status === "converted" ? "Converted" : "Abandoned" }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column min-width="140px" label="Last activity">
                  <template slot="header">
                    <span @click="sortByColumn(7)">
                      Last activity
                      <i
                        v-if="sortedColumn === 7 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else-if="sortedColumn === 7"
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ formatDate(props.row.last_modified_at || props.row.created_at) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="d-flex justify-content-end" slot="footer">
            <nav v-if="tableData.length > 0 || totalData > 0">
              <div class="row">
                <div class="col-md-12">
                  <ul
                    class="pagination custompagination justify-content-end align-items-center"
                  >
                    <p class="p-0 m-0 mr-2">
                      Showing {{ tableData.length }} of {{ totalData }} entries
                    </p>
                    <li :class="{ disabled: currentPage === 1 }" class="page-item">
                      <a
                        @click.prevent="changePage(currentPage - 1)"
                        class="page-link"
                        href="#"
                      ><i class="fa fa-caret-left"></i></a>
                    </li>
                    <li
                      v-for="(page, index) in pagesNumber"
                      :key="index"
                      :class="{ active: page == currentPage }"
                      class="page-item"
                    >
                      <a
                        @click.prevent="changePage(page)"
                        class="page-link"
                        href="javascript:void(0)"
                      >{{ page }}</a>
                    </li>
                    <li
                      :class="{ disabled: currentPage === last_page }"
                      class="page-item"
                    >
                      <a
                        @click.prevent="changePage(currentPage + 1)"
                        class="page-link"
                        href="#"
                      ><i class="fa fa-caret-right"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </card>
      </div>
    </div>

    <el-dialog
      title="Lead Details"
      :visible.sync="detailModalVisible"
      :width="leadDetailDialogWidth"
      class="lead-detail-dialog"
      :close-on-click-modal="true"
      @close="closeLeadDetail"
    >
      <div v-loading="detailLoading" class="lead-detail-body">
        <template v-if="detailLead && !detailLoading">
          <!-- Hero strip -->
          <div class="lead-detail-hero">
            <div class="lead-detail-hero-inner">
            
              <div class="lead-detail-hero-text">
                <h2 class="lead-detail-name">
                  {{ detailValue(detailLead.first_name) }} {{ detailValue(detailLead.last_name) }}
                </h2>
                <p v-if="detailLead.company_name" class="lead-detail-company">Company: {{ detailLead.company_name }}</p>
                <span :class="['lead-detail-status', detailLead.status]">
                  {{ detailLead.status === 'converted' ? 'Converted' : 'Abandoned' }}
                </span>
              </div>
            </div>
          </div>

          <div class="lead-detail-sections">
            <!-- Contact -->
            <section class="lead-detail-block">
              <h3 class="lead-detail-block-title">Contact</h3>
              <div class="lead-detail-list">
                <div class="lead-detail-item">
                  <span class="lead-detail-item-label">Email</span>
                  <a v-if="detailLead.email" :href="'mailto:' + detailLead.email" class="lead-detail-item-value link">{{ detailLead.email }}</a>
                  <span v-else class="lead-detail-item-value empty">—</span>
                </div>
                <div class="lead-detail-item">
                  <span class="lead-detail-item-label">Phone</span>
                  <span class="lead-detail-item-value">{{ detailValue(detailLead.phone_num) }}</span>
                </div>
                <div class="lead-detail-item">
                  <span class="lead-detail-item-label">Address</span>
                  <span class="lead-detail-item-value">{{ detailValue(detailLead.address) }}{{ detailLead.state_id ? ' · ' + detailLead.state_id : '' }}</span>
                </div>
              </div>
            </section>

            <!-- Account -->
            <section class="lead-detail-block">
              <h3 class="lead-detail-block-title">Account</h3>
              <div class="lead-detail-list">
                <div class="lead-detail-item lead-detail-item-inline">
                  <span class="lead-detail-item-label">Type</span>
                  <span class="lead-detail-item-value">{{ detailLead.user_type ? detailLead.user_type.charAt(0).toUpperCase() + detailLead.user_type.slice(1) : "—" }}</span>
                </div>
                <div class="lead-detail-item lead-detail-item-inline">
                  <span class="lead-detail-item-label">Locations / Employees</span>
                  <span class="lead-detail-item-value">{{ detailValue(detailLead.number_of_locations) }} / {{ detailValue(detailLead.number_of_employees) }}</span>
                </div>
                <div class="lead-detail-item">
                  <span class="lead-detail-item-label">Plan</span>
                  <span class="lead-detail-item-value plan">{{ formatPlanName(detailLead.plan || detailLead.selected_course_type) }}</span>
                </div>
                <div class="lead-detail-item">
                  <span class="lead-detail-item-label">Courses</span>
                  <div class="lead-detail-item-value">
                    <template v-if="detailLead.course_names && detailLead.course_names.length">
                      <span v-for="c in detailLead.course_names" :key="c.id" class="tag">{{ c.name }}</span>
                    </template>
                    <span v-else class="empty">—</span>
                  </div>
                </div>
                <div v-if="detailLead.special_course_names && detailLead.special_course_names.length" class="lead-detail-item">
                  <span class="lead-detail-item-label">Special courses</span>
                  <div class="lead-detail-item-value">
                    <span v-for="(sc, i) in detailLead.special_course_names" :key="i" class="tag">{{ sc.name }} ({{ sc.users }})</span>
                  </div>
                </div>
                <div class="lead-detail-item">
                  <span class="lead-detail-item-label">Add-ons</span>
                  <div class="lead-detail-item-value">
                    <template v-if="parseAddonsIds(detailLead.addons_ids).length">
                      <span v-for="key in parseAddonsIds(detailLead.addons_ids)" :key="key" class="tag tag-addon">{{ addonKeyToLabel(key) }}</span>
                    </template>
                    <span v-else class="empty">—</span>
                  </div>
                </div>
                <div class="lead-detail-item lead-detail-item-inline">
                  <span class="lead-detail-item-label">Promo code</span>
                  <span class="lead-detail-item-value">{{ detailValue(detailLead.promo_code) }}</span>
                </div>
              </div>
            </section>

            <!-- Pricing -->
            <section class="lead-detail-block lead-detail-pricing">
              <h3 class="lead-detail-block-title">Pricing</h3>
              <div class="lead-detail-price-main">
                <span class="lead-detail-price-amount">{{ detailMoney(detailLead.cost_per_month) }}</span>
                <span class="lead-detail-price-period">/ month</span>
              </div>
              <div class="lead-detail-price-meta">
                <div class="lead-detail-price-row">
                  <span>Discounted</span>
                  <span>{{ detailMoney(detailLead.discounted_cost) }}</span>
                </div>
                <div class="lead-detail-price-row">
                  <span>Per year</span>
                  <span>{{ detailMoney(detailLead.total_cost_per_year) }}</span>
                </div>
                <div class="lead-detail-price-row">
                  <span>Per location</span>
                  <span>{{ detailMoney(detailLead.per_location) }}</span>
                </div>
                <div class="lead-detail-price-row">
                  <span>Per user</span>
                  <span>{{ detailMoney(detailLead.per_user) }}</span>
                </div>
              </div>
            </section>

            <!-- Meta -->
            <section class="lead-detail-block lead-detail-meta">
              <div class="lead-detail-meta-row">
                <span class="lead-detail-item-label">Ref code</span>
                <span class="lead-detail-item-value">{{ detailValue(detailLead.ref_code) }}</span>
              </div>
              <div class="lead-detail-meta-row">
                <span class="lead-detail-item-label">Created</span>
                <span class="lead-detail-item-value">{{ formatDate(detailLead.created_at) }}</span>
              </div>
              <div class="lead-detail-meta-row">
                <span class="lead-detail-item-label">Last activity</span>
                <span class="lead-detail-item-value">{{ formatDate(detailLead.last_modified_at || detailLead.updated_at) }}</span>
              </div>
            </section>
          </div>
        </template>
      </div>
      <span slot="footer" class="lead-detail-footer">
        <el-button
          v-if="detailLead && detailLead.email"
          type="success"
          icon="el-icon-message"
          @click="openSendEmail"
        >Send email</el-button>
        <el-button type="primary" @click="closeLeadDetail">Close</el-button>
      </span>
    </el-dialog>

    <!-- Send email to lead (abandon cart) -->
    <el-dialog
      title="Send email to lead"
      :visible.sync="sendEmailModalVisible"
      width="560px"
      class="lead-send-email-dialog"
      :close-on-click-modal="false"
      @close="closeSendEmail"
    >
      <div class="lead-send-email-form">
        <div class="form-group">
          <label>Template</label>
          <el-select
            v-model="selectedEmailTemplate"
            placeholder="Select a template"
            class="w-100"
            filterable
          >
            <el-option
              v-for="t in emailTemplates"
              :key="t.id"
              :label="t.template_name"
              :value="t.id"
            />
          </el-select>
        </div>
        <div class="form-group">
          <label>Subject</label>
          <base-input
            v-model="emailSubject"
            placeholder="Email subject"
          />
        </div>
        <div class="form-group">
          <label>Message (replaces {message} in template)</label>
          <textarea
            v-model="emailMessage"
            class="form-control lead-email-message"
            rows="6"
            placeholder="Enter the message body..."
          />
        </div>
        <div class="form-group lead-include-info-wrap">
          <el-checkbox v-model="includeLeadInfo">
            Include lead information in the email
          </el-checkbox>
          <p class="lead-include-info-hint">When checked, a formatted summary (name, company, plan, pricing, etc.) is added below your message.</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeSendEmail">Cancel</el-button>
        <el-button :loading="previewLoading" @click="previewEmail">Preview</el-button>
        <el-button type="primary" :loading="emailSending" @click="sendLeadEmail">Send via Mailgun</el-button>
      </span>
    </el-dialog>

    <!-- Email preview modal -->
    <el-dialog
      title="Email preview"
      :visible.sync="previewModalVisible"
      width="640px"
      class="lead-email-preview-dialog"
      @close="closePreview"
    >
      <div v-if="previewSubject" class="preview-subject"><strong>Subject:</strong> {{ previewSubject }}</div>
      <div class="preview-html-wrap" v-html="previewHtml" />
      <span slot="footer">
        <el-button type="primary" @click="closePreview">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
.no-border-card .card-footer {
  border-top: 0;
}
.badge-success,
.lead-detail-badge.badge-success { background-color: #2dce89; color: #fff; }
.badge-warning,
.lead-detail-badge.badge-warning { background-color: #fb6340; color: #fff; }
.compGrid-clickable >>> .el-table__body tr { cursor: pointer; }

/* ——— Lead detail dialog ——— */
.lead-detail-dialog >>> .el-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}
.lead-detail-dialog >>> .el-dialog__header {
  padding: 1rem 1.5rem;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.lead-detail-dialog >>> .el-dialog__header .el-dialog__title { font-size: 1.1rem; font-weight: 600; color: #1a1a1a; }
.lead-detail-dialog >>> .el-dialog__body {
  padding: 0;
  max-height: 70vh;
  overflow-y: auto;
  background: #f5f5f7;
}
.lead-detail-dialog >>> .el-dialog__footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #eee;
  background: #fff;
}
.lead-detail-footer >>> .el-button { border-radius: 8px; font-weight: 500; }
.lead-detail-footer >>> .el-button--success { margin-right: 0.5rem; }

.lead-detail-body { min-height: 160px; }

/* Send email dialog */
.lead-send-email-dialog .lead-send-email-form { padding: 0.5rem 0; }
.lead-send-email-dialog .form-group { margin-bottom: 1rem; }
.lead-send-email-dialog .form-group label { display: block; font-size: 0.8rem; font-weight: 600; color: #555; margin-bottom: 0.35rem; }
.lead-send-email-dialog .lead-email-message { width: 100%; padding: 0.5rem 0.75rem; border: 1px solid #dcdfe6; border-radius: 6px; font-size: 0.9rem; resize: vertical; }
.lead-send-email-dialog .w-100 { width: 100%; }
.lead-send-email-dialog .lead-include-info-wrap { margin-top: 1rem; padding: 0.75rem 1rem; background: #f8f9fc; border-radius: 8px; border: 1px solid #e8eaef; }
.lead-send-email-dialog .lead-include-info-wrap >>> .el-checkbox__label { font-weight: 500; color: #333; }
.lead-send-email-dialog .lead-include-info-hint { margin: 0.4rem 0 0 1.8rem; font-size: 0.78rem; color: #666; line-height: 1.4; }

/* Email preview dialog */
.lead-email-preview-dialog .preview-subject { margin-bottom: 0.75rem; padding-bottom: 0.75rem; border-bottom: 1px solid #eee; font-size: 0.9rem; }
.lead-email-preview-dialog .preview-html-wrap { max-height: 70vh; overflow: auto; border: 1px solid #eee; border-radius: 8px; padding: 1rem; background: #fff; }
.lead-email-preview-dialog .preview-html-wrap >>> img { max-width: 100%; height: auto; }

/* Hero */
.lead-detail-hero {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  color: #fff;
  padding: 1.5rem 1.5rem 1.25rem;
}
.lead-detail-hero-inner {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.lead-detail-avatar {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  flex-shrink: 0;
}
.lead-detail-hero-text { min-width: 0; }
.lead-detail-name {
  color:white;
  margin: 0 0 0.2rem 0;
  font-size: 1.35rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.3;
}
.lead-detail-company {
  margin: 0 0 0.5rem 0;
  font-size: 0.875rem;
  opacity: 0.85;
}
.lead-detail-status {
  display: inline-block;
  padding: 0.25rem 0.6rem;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 6px;
}
.lead-detail-status.converted { background: rgba(45, 206, 137, 0.25); color: #2dce89; }
.lead-detail-status.abandoned { background: rgba(251, 99, 64, 0.25); color: #ffb199; }

/* Sections */
.lead-detail-sections { padding: 1rem 1.5rem 1.5rem; }
.lead-detail-block {
  background: #fff;
  border-radius: 10px;
  padding: 1.1rem 1.25rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.lead-detail-block:last-child { margin-bottom: 0; }
.lead-detail-block-title {
  margin: 0 0 0.75rem 0;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #888;
}
.lead-detail-list { display: flex; flex-direction: column; gap: 0.65rem; }
.lead-detail-item { display: flex; flex-direction: column; gap: 0.15rem; }
.lead-detail-item-inline {
  flex-direction: row;
  align-items: baseline;
  gap: 0.5rem;
}
.lead-detail-item-label {
  font-size: 0.75rem;
  color: #888;
  font-weight: 500;
}
.lead-detail-item-inline .lead-detail-item-label { flex: 0 0 150px; }
.lead-detail-item-value {
  font-size: 0.9rem;
  color: #222;
  word-break: break-word;
}
.lead-detail-item-value.empty { color: #aaa; }
.lead-detail-item-value.plan { font-weight: 600; color: #1a1a2e; }
.lead-detail-item-value.link {
  color: #e66412;
  text-decoration: none;
}
.lead-detail-item-value.link:hover { text-decoration: underline; }
.tag {
  display: inline-block;
  margin: 0.15rem 0.35rem 0.15rem 0;
  padding: 0.25rem 0.6rem;
  font-size: 0.78rem;
  background: #f0f0f2;
  color: #444;
  border-radius: 6px;
}
.tag-addon { background: #fff4ed; color: #c45a2b; }
.tag:first-of-type { margin-left: 0; }

/* Pricing block */
.lead-detail-pricing { padding: 1.25rem 1.25rem; }
.lead-detail-price-main {
  margin-bottom: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #eee;
}
.lead-detail-price-amount {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1a1a2e;
  letter-spacing: -0.02em;
}
.lead-detail-price-period { font-size: 0.9rem; color: #888; font-weight: 400; margin-left: 0.2rem; }
.lead-detail-price-meta { display: flex; flex-direction: column; gap: 0.4rem; }
.lead-detail-price-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  color: #555;
}
.lead-detail-price-row span:last-child { font-weight: 600; color: #333; }

/* Meta block */
.lead-detail-meta {
  background: #fafafa;
  padding: 0.9rem 1.25rem;
}
.lead-detail-meta-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
  padding: 0.35rem 0;
  font-size: 0.85rem;
}
.lead-detail-meta-row .lead-detail-item-label { margin: 0; }
.lead-detail-meta-row .lead-detail-item-value { font-size: 0.85rem; }

/* Lead detail dialog — mobile responsive */
@media (max-width: 768px) {
  .lead-detail-dialog >>> .el-dialog {
    margin: 1.5vh auto !important;
    max-width: calc(100vw - 1rem);
  }
  .lead-detail-dialog >>> .el-dialog__header,
  .lead-detail-dialog >>> .el-dialog__footer {
    padding: 0.875rem 1rem;
  }
  .lead-detail-dialog >>> .el-dialog__body {
    max-height: 75vh;
  }
  .lead-detail-hero {
    padding: 1.25rem 1rem 1rem;
  }
  .lead-detail-hero-inner {
    gap: 0.75rem;
  }
  .lead-detail-avatar {
    width: 44px;
    height: 44px;
    font-size: 0.95rem;
  }
  .lead-detail-name {
    font-size: 1.15rem;
  }
  .lead-detail-company {
    font-size: 0.8rem;
  }
  .lead-detail-sections {
    padding: 0.875rem 1rem 1.25rem;
  }
  .lead-detail-block {
    padding: 1rem 1rem;
    margin-bottom: 0.6rem;
  }
  .lead-detail-block-title {
    margin-bottom: 0.6rem;
    font-size: 0.68rem;
  }
  .lead-detail-item-inline {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.2rem;
  }
  .lead-detail-item-inline .lead-detail-item-label {
    flex: none;
  }
  .lead-detail-price-amount {
    font-size: 1.4rem;
  }
  .lead-detail-price-period {
    font-size: 0.85rem;
  }
  .lead-detail-pricing {
    padding: 1rem 1rem;
  }
  .lead-detail-meta {
    padding: 0.75rem 1rem;
  }
  .lead-detail-meta-row {
    padding: 0.3rem 0;
    font-size: 0.8rem;
  }
  .tag {
    font-size: 0.72rem;
    padding: 0.2rem 0.5rem;
    margin: 0.1rem 0.25rem 0.1rem 0;
  }
}

@media (max-width: 480px) {
  .lead-detail-dialog >>> .el-dialog {
    margin: 0.5rem !important;
    width: calc(100vw - 1rem) !important;
    max-width: none;
    border-radius: 10px;
  }
  .lead-detail-dialog >>> .el-dialog__body {
    max-height: 85vh;
  }
  .lead-detail-hero {
    padding: 1rem 0.875rem;
  }
  .lead-detail-avatar {
    width: 40px;
    height: 40px;
    font-size: 0.9rem;
  }
  .lead-detail-name {
    font-size: 1.05rem;
  }
  .lead-detail-status {
    font-size: 0.65rem;
    padding: 0.2rem 0.5rem;
  }
  .lead-detail-sections {
    padding: 0.75rem 0.875rem 1rem;
  }
  .lead-detail-block {
    padding: 0.875rem 0.875rem;
    border-radius: 8px;
  }
  .lead-detail-item-value {
    font-size: 0.85rem;
  }
  .lead-detail-price-amount {
    font-size: 1.25rem;
  }
  .lead-detail-price-row {
    font-size: 0.8rem;
  }
  .lead-detail-footer >>> .el-button {
    width: 100%;
  }
}

@media only screen and (max-width: 1024px) {
  .compGrid >>> table.el-table__body td:nth-of-type(1):before {
    content: "First Name";
  }
  .compGrid >>> table.el-table__body td:nth-of-type(2):before {
    content: "Last Name";
  }
  .compGrid >>> table.el-table__body td:nth-of-type(3):before {
    content: "Email";
  }
  .compGrid >>> table.el-table__body td:nth-of-type(4):before {
    content: "Company";
  }
  .compGrid >>> table.el-table__body td:nth-of-type(5):before {
    content: "Type";
  }
  .compGrid >>> table.el-table__body td:nth-of-type(6):before {
    content: "Plan";
  }
  .compGrid >>> table.el-table__body td:nth-of-type(7):before {
    content: "Locations / Users";
  }
  .compGrid >>> table.el-table__body td:nth-of-type(8):before {
    content: "Add-ons";
  }
  .compGrid >>> table.el-table__body td:nth-of-type(9):before {
    content: "Est. cost/mo";
  }
  .compGrid >>> table.el-table__body td:nth-of-type(10):before {
    content: "Per loc / user";
  }
  .compGrid >>> table.el-table__body td:nth-of-type(11):before {
    content: "Status";
  }
  .compGrid >>> table.el-table__body td:nth-of-type(12):before {
    content: "Last activity";
  }
}
</style>
